import classnames from 'classnames';
import React, { useMemo } from 'react';
import styleIcon from './Icon.scss';
const Icon = ({ name, src, hoverName, className = '', style = {}, badge = '', type = '', hoverTitle = '', hasBackground = false, isDisabled = false, onClick, dataCy, }) => {
    const prefix = useMemo(() => {
        switch (type) {
            case 'fa':
                return 'fa fa-';
            case 'pgt':
                return 'pgt';
            case 'ed':
                return 'ed';
            case 'image':
                return '';
            default:
                return 'icon-';
        }
    }, [type]);
    const iconName = useMemo(() => {
        switch (type) {
            case 'fa':
                return (name === null || name === void 0 ? void 0 : name.startsWith(prefix)) ? name : `fa fa-${name}`;
            case 'material':
                return 'material-icons';
            case 'tree-icon':
                return styleIcon.treeIcon;
            case 'image':
                return styleIcon.imageIcon;
            default:
                return name && name.startsWith(prefix) ? name : `icon-${name}`;
        }
    }, [prefix, name, type]);
    const iconHoverName = useMemo(() => {
        if (!hoverName) {
            return undefined;
        }
        switch (type) {
            case 'fa':
                return hoverName.startsWith(prefix) ? hoverName : `fa fa-${hoverName}`;
            case 'material':
                return 'material-icons';
            case 'tree-icon':
                return styleIcon.treeIcon;
            case 'image':
                return styleIcon.imageIcon;
            default:
                return hoverName && hoverName.startsWith(prefix)
                    ? hoverName
                    : `icon-${hoverName}`;
        }
    }, [prefix, hoverName, type]);
    const backgroundClass = hasBackground ? styleIcon.iconWithBackground : '';
    return (<>
      {type === 'image' && (<img className={classnames(className, iconName)} data-cy={dataCy} src={src}/>)}
      {
    /* eslint-disable react/forbid-dom-props */
    type !== 'image' && (<i className={classnames(className, iconName, backgroundClass, styleIcon.hoverContainer, { [styleIcon.disabled]: isDisabled })} data-cy={dataCy} style={style} title={hoverTitle} onClick={onClick}>
            {badge && <span className="notification-counts">{badge}</span>}

            {iconHoverName ? (<i className={classnames(className, iconHoverName, backgroundClass, styleIcon.hoverContent)} style={style} title={hoverTitle}/>) : null}
          </i>)}
    </>);
};
export default Icon;
